import { autoUpdate, offset, useFloating } from '@floating-ui/react-dom';

export const useSetupFloating = ({ referenceElement, floatingElement, placement }) => {
  return useFloating({
    elements: {
      floating: floatingElement,
      reference: referenceElement,
    },
    placement,
    middleware: [offset(4)],
    whileElementsMounted: autoUpdate,
  });
};
